<td>
  <button (click)="pullUp(domain, domains)" class="btn_img btn_graygray btn_up"></button>
  <button (click)="pullDown(domain, domains)" class="btn_img btn_graygray btn_down"></button>
</td>

<td>
  {{'IP/Domain'|translate }} <input type="text" [(ngModel)]="domain.Name" />
  {{'Title'|translate }}<input type="text" [(ngModel)]="domain.Title" />
  {{'Key'|translate }}<input type="text" [(ngModel)]="domain.Key" />
</td>
<td>
  {{'Logo'|translate }}<input type="text" [(ngModel)]="domain.LogoLink" />
  {{'Apple Store'|translate }}<input type="text" [(ngModel)]="domain.AppleStoreLink" />
  {{'Play Market'|translate }}<input type="text" [(ngModel)]="domain.PlayMarketLink" />
</td>

<td><image-upload #outerlogo [uploaded]="['/OuterLogo/'+ domain.Id]" (onFileUploadFinish)="UpdateOuterLogo()" (onRemove)="UpdateOuterLogo()"></image-upload></td>
<td><image-upload #innerlogo [uploaded]="['/InnerLogo/'+ domain.Id]" (onFileUploadFinish)="UpdateInnerLogo()" (onRemove)="UpdateInnerLogo()"></image-upload></td>
<td><image-upload #favicon [uploaded]="['/FavIcon/'+ domain.Id]" (onFileUploadFinish)="UpdateFavicon()" (onRemove)="UpdateFavicon()"></image-upload></td>

<td><button class="btn_img btn_trush" (click)="deleteItem(domain, domains)" data-toggle="tooltip" data-placement="top" title="{{'Delete'|translate}}"></button></td>
